module.exports = __webpack_public_path__ + "stu-res/img/course-5.3ed5dc46.png";